module.exports = __webpack_public_path__ + "static/logo-dark-45887eb404eb332993e63df7970894e9.png";